/* eslint-disable import/no-extraneous-dependencies */
import React, { PropTypes } from 'react'
import moment from 'moment'
import { dateFormatter } from 'lib/helpers'
import { Table, Thead, Th, Tr, Td } from 'components/reactable'
import translate from '../translation'

const Documents = ({ docs }) => {
	const formatedDates = docs ? docs.map(item => ({...item, documentDate: moment(item.documentDate).format("DD-MM-YYYY")})) : []

	return (
		<div className={`docContainer`}>
			<Table
				className={`table`}
				itemsPerPage={10}
				filterable={['documentType', 'documentDate']}
				sortable={[
				{column: 'documentDate', sortFunction: 'Date'},
					'documentType',
				]}
				defaultSort={{
					column: 'documentDate',
					direction: 'desc',
				}}
			>
				<Thead>
					<Th column="documentIcon" label=""/>
					<Th column="documentType">
						<span>{translate('fileType')}</span>
					</Th>
					<Th column="documentDate">
						<span>{translate('fileDate')}</span>
					</Th>
				</Thead>
				{
					formatedDates.map((item, key) =>
						<Tr
							className={`docRow`}
							onClick={() => window.open(`/data/document?id=${item.documentId}`, '_blank', 'noopener,noreferrer')} key={key}
							data={item}
						>
							<Td column="documentIcon">
								<div className="rowIcon">
									<img src={require('resources/images/pdf-icon_1x.png')}/>
								</div>
							</Td>
							<Td className={`documentType`} column="documentType"/>
							<Td column="documentDate" data={dateFormatter(item.documentDate)}/>
						</Tr>
					)
				}
			</Table>
		</div>
	)
}
Documents.propTypes = {
    docs: PropTypes.arrayOf(PropTypes.object),
}

export default Documents



// WEBPACK FOOTER //
// ./components/office/finances/FinancesDocuments.jsx